module.exports = __webpack_public_path__ + "media/day/329-231d85c2.svg";